// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  align-self: center;
  max-width: 900px;
  width: 100%;
}
:host .mat-mdc-table {
  margin-top: 10px;
}
:host ::ng-deep .mat-mdc-table {
  background: inherit !important;
}
:host ::ng-deep mat-table > .mat-mdc-cell {
  overflow: auto;
}
:host ::ng-deep mat-header-row {
  display: none;
}
:host ::ng-deep mat-row {
  border: none;
}
:host ::ng-deep mat-cell {
  border-bottom: none;
  overflow: unset;
}
:host ::ng-deep o-note {
  width: 100%;
}

@media print {
  mat-row {
    display: block;
    min-height: 0;
  }
  mat-cell {
    display: block;
  }
  ::ng-deep o-note {
    page-break-inside: avoid;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vdGUtbGlzdC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxXQUFBO0FBQ0Y7QUFDRTtFQUNFLGdCQUFBO0FBQ0o7QUFHSTtFQUNFLDhCQUFBO0FBRE47QUFJSTtFQUNFLGNBQUE7QUFGTjtBQUtJO0VBQ0UsYUFBQTtBQUhOO0FBTUk7RUFDRSxZQUFBO0FBSk47QUFPSTtFQUNFLG1CQUFBO0VBQ0EsZUFBQTtBQUxOO0FBUUk7RUFDRSxXQUFBO0FBTk47O0FBV0E7RUFDRTtJQUNFLGNBQUE7SUFDQSxhQUFBO0VBUkY7RUFXQTtJQUNFLGNBQUE7RUFURjtFQVlBO0lBQ0Usd0JBQUE7RUFWRjtBQUNGIiwiZmlsZSI6Im5vdGUtbGlzdC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgYWxpZ24tc2VsZjogY2VudGVyO1xuICBtYXgtd2lkdGg6IDkwMHB4O1xuICB3aWR0aDogMTAwJTtcblxuICAubWF0LW1kYy10YWJsZSB7XG4gICAgbWFyZ2luLXRvcDogMTBweDtcbiAgfVxuXG4gIDo6bmctZGVlcCB7XG4gICAgLm1hdC1tZGMtdGFibGUge1xuICAgICAgYmFja2dyb3VuZDogaW5oZXJpdCAhaW1wb3J0YW50O1xuICAgIH1cblxuICAgIG1hdC10YWJsZSA+IC5tYXQtbWRjLWNlbGwge1xuICAgICAgb3ZlcmZsb3c6IGF1dG87XG4gICAgfVxuXG4gICAgbWF0LWhlYWRlci1yb3cge1xuICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG5cbiAgICBtYXQtcm93IHtcbiAgICAgIGJvcmRlcjogbm9uZTtcbiAgICB9XG5cbiAgICBtYXQtY2VsbCB7XG4gICAgICBib3JkZXItYm90dG9tOiBub25lO1xuICAgICAgb3ZlcmZsb3c6IHVuc2V0O1xuICAgIH1cblxuICAgIG8tbm90ZSB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gIH1cbn1cblxuQG1lZGlhIHByaW50IHtcbiAgbWF0LXJvdyB7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgbWluLWhlaWdodDogMDtcbiAgfVxuXG4gIG1hdC1jZWxsIHtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgfVxuXG4gIDo6bmctZGVlcCBvLW5vdGUge1xuICAgIHBhZ2UtYnJlYWstaW5zaWRlOiBhdm9pZDtcbiAgfVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./apps/viewer/src/app/toc-items/note-module/note-list/note-list.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AACF;AACE;EACE,gBAAA;AACJ;AAGI;EACE,8BAAA;AADN;AAII;EACE,cAAA;AAFN;AAKI;EACE,aAAA;AAHN;AAMI;EACE,YAAA;AAJN;AAOI;EACE,mBAAA;EACA,eAAA;AALN;AAQI;EACE,WAAA;AANN;;AAWA;EACE;IACE,cAAA;IACA,aAAA;EARF;EAWA;IACE,cAAA;EATF;EAYA;IACE,wBAAA;EAVF;AACF;AACA,49CAA49C","sourcesContent":[":host {\n  align-self: center;\n  max-width: 900px;\n  width: 100%;\n\n  .mat-mdc-table {\n    margin-top: 10px;\n  }\n\n  ::ng-deep {\n    .mat-mdc-table {\n      background: inherit !important;\n    }\n\n    mat-table > .mat-mdc-cell {\n      overflow: auto;\n    }\n\n    mat-header-row {\n      display: none;\n    }\n\n    mat-row {\n      border: none;\n    }\n\n    mat-cell {\n      border-bottom: none;\n      overflow: unset;\n    }\n\n    o-note {\n      width: 100%;\n    }\n  }\n}\n\n@media print {\n  mat-row {\n    display: block;\n    min-height: 0;\n  }\n\n  mat-cell {\n    display: block;\n  }\n\n  ::ng-deep o-note {\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
